"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoutikMultilocalePlugin = void 0;
const fs_1 = __importDefault(require("fs"));
const path_1 = __importDefault(require("path"));
const localization_context_definition_1 = require("./localization-context/localization-context-definition");
const localization_context_1 = require("./localization-context/localization-context");
const inject_manifest_plugin_definition_1 = require("./injectors/inject-manifest-plugin-definition");
const inject_site_metadata_definition_1 = require("./injectors/inject-site-metadata-definition");
class BoutikMultilocalePlugin {
    constructor() {
        this.onPreInit = (gatsbyContext, options) => __awaiter(this, void 0, void 0, function* () {
            console.log("\x1b[35m%s\x1b[0m", "SBI... Loaded boutik-gatsby-plugin-multi");
            if (!!this.store) {
                gatsbyContext.reporter.panic(`gatsby-theme-boutik-multilocale has already been initialized. This most certainly indicates that it is declared twice in gatsby-node.js.`);
                throw new Error(`Already initialized`);
            }
            this.store = gatsbyContext.store;
            this.reporter = gatsbyContext.reporter;
            this.options = this.injectDefaultOptions(options);
            if (!fs_1.default.existsSync(this.options.configPath)) {
                this.reporter.panicOnBuild(`Couldn't find locales definition file at '${this.options.configPath}'`);
                throw new Error(`Couldn't find locales definition file`);
            }
            this.reporter.info(`Locales definition file found at ${this.options.configPath}`);
            let spec;
            try {
                spec = require(this.options.configPath);
            }
            catch (e) {
                this.reporter.panicOnBuild('Error while loading locales definition file', e);
                throw new Error('Error while loading locales definition file');
            }
            this.parsedDefinition = (0, localization_context_definition_1.parseDefinition)(spec);
            this.localizationData = yield this.loadLocalizationFiles();
            this._localizationContext = yield new localization_context_1.LocalizationContext(this.parsedDefinition, (locale) => this.localizationData[locale]).init();
            (0, inject_site_metadata_definition_1.injectSiteMetadataDefinition)();
            (0, inject_manifest_plugin_definition_1.injectManifestPluginDefinition)(this);
        });
        this.onPreBootstrap = ({ cache, }) => __awaiter(this, void 0, void 0, function* () {
            const localizationDataDir = path_1.default.join(cache.directory, 'i18n');
            if (!fs_1.default.existsSync(localizationDataDir)) {
                // JWH 20201218: For some unknown reason, the { recusrsive: true } argument is
                //               not accepted by TypeScript at runtime. Might be related with some
                //               versionning issues in ts-node, though I have not yet found why.
                //               For now, casting `fs` to `any` masks the issue.
                fs_1.default.mkdirSync(localizationDataDir, { recursive: true });
            }
            for (let locale of Object.keys(this.localizationData)) {
                fs_1.default.writeFileSync(path_1.default.join(localizationDataDir, `${locale}.json`), JSON.stringify(this.localizationData[locale]));
            }
        });
        this.onCreateWebpackConfig = ({ plugins, actions, cache, getConfig }) => {
            console.log("\x1b[35m%s\x1b[0m", "onCreateWebpackConfig...");
            const localizationDataDir = path_1.default.join(cache.directory, `i18n`);
            const config = getConfig();
            const multilocalPlugins = plugins.define({
                __BOUTIK_MULTILOCALE_DEFINITION__: JSON.stringify(this.parsedDefinition),
                __BOUTIK_MULTILOCALE_DATADIR__: JSON.stringify(localizationDataDir),
            });
            const miniCssExtractPlugin = config.plugins.find((plugin) => plugin.constructor.name === 'MiniCssExtractPlugin');
            if (miniCssExtractPlugin) {
                miniCssExtractPlugin.options.ignoreOrder = true;
                config.plugins.push(multilocalPlugins);
                actions.replaceWebpackConfig(config);
            }
            else {
                actions.setWebpackConfig({
                    plugins: [
                        multilocalPlugins
                    ],
                });
            }
        };
        this.onCreatePage = (gatsbyContext) => {
            var _a;
            let { page, actions } = gatsbyContext;
            let { createPage, deletePage } = actions;
            // Don't reprocess this page if locale has already been defined; doing so would get us in an endless loop.
            if (!!page.context.locale)
                return;
            if (page.path === '/dev-404-page/')
                return;
            let originalPath = (_a = page.context.pathTranslated) !== null && _a !== void 0 ? _a : page.path;
            let localizedPath = this.localizationContext.localizePath(originalPath);
            let localizedMatchPath = page.matchPath
                ? this.localizationContext.localizePath(page.matchPath)
                : {};
            if (page.path === '/404/') {
                // If the page is the 404, then add a synthetic matchPath on /${localeRoot}/*
                // for example: /ca/fr/*
                localizedMatchPath = Object.fromEntries(Object.entries(this.localizationContext.localizePath('/')).map(([locale, localizedPath]) => [
                    locale,
                    localizedPath + '*',
                ]));
            }
            deletePage(page);
            for (let [localeCode, path] of Object.entries(localizedPath)) {
                createPage(Object.assign(Object.assign({}, page), { path: path, matchPath: localizedMatchPath[localeCode], context: Object.assign(Object.assign({}, page.context), { locale: localeCode, alternatives: localizedPath }) }));
            }
            // FIXME: This definitely does not belong here, but it doesn't work to put it elsewhere,
            // due to processing order issue: this plugin's onCreatePage() gets called before the other one,
            // and then, the other one can't identify that this is the page that needs to be intercepted...
            // --JWH 20210106
            if (page.path.match(/^\/account/) &&
                typeof page.matchPath === 'undefined') {
                for (let [localeCode, path] of Object.entries(localizedPath)) {
                    createPage(Object.assign(Object.assign({}, page), { path: path, matchPath: path + '*', context: Object.assign(Object.assign({}, page.context), { locale: localeCode, alternatives: localizedPath }) }));
                }
            }
        };
    }
    injectDefaultOptions(themeOptions = {}) {
        var _a, _b, _c;
        let { program } = this.store.getState();
        const defaultConfigPath = path_1.default.join(program.directory, 'src/i18n/config.json');
        themeOptions.configPath = (_a = themeOptions.configPath) !== null && _a !== void 0 ? _a : defaultConfigPath;
        themeOptions.injectSiteManifestDefinition =
            (_b = themeOptions.injectSiteManifestDefinition) !== null && _b !== void 0 ? _b : 'auto';
        themeOptions.injectManifestPluginDefinition =
            (_c = themeOptions.injectManifestPluginDefinition) !== null && _c !== void 0 ? _c : 'auto';
        return themeOptions;
    }
    findLocalizationDirectories() {
        let { flattenedPlugins } = this.store.getState();
        let localizationDirectories = [];
        let pluginsDirectory = flattenedPlugins
            .map((plugin) => plugin.resolve)
            .filter((x) => !!x); // Filter out plugins that don't have a properly defined path.
        // This is not expected at runtime, but happens in tests.
        for (let directory of pluginsDirectory) {
            const pluginI18nDirectory = path_1.default.join(directory, 'src/i18n');
            try {
                if (fs_1.default.statSync(pluginI18nDirectory).isDirectory()) {
                    this.reporter.info(`Localization directory found at ${pluginI18nDirectory}`);
                    localizationDirectories.push(pluginI18nDirectory);
                }
            }
            catch (e) {
                // Ignore file do not exists exceptions
            }
            const pluginI18nDirectoryDist = path_1.default.join(directory, 'dist/src/i18n');
            try {
                if (fs_1.default.statSync(pluginI18nDirectoryDist).isDirectory()) {
                    this.reporter.info(`Localization directory found at ${pluginI18nDirectoryDist}`);
                    localizationDirectories.push(pluginI18nDirectoryDist);
                }
            }
            catch (e) {
                // Ignore file do not exists exceptions
            }
        }
        return localizationDirectories;
    }
    loadLocalizationFiles() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let localizationDirectories = yield this.findLocalizationDirectories();
            let localizationData = {};
            for (let locale of Object.keys(this.parsedDefinition.locales)) {
                localizationData[locale] = {};
                for (let dir of localizationDirectories) {
                    let localeDirectory = path_1.default.join(dir, locale);
                    if (fs_1.default.statSync(localeDirectory).isDirectory()) {
                        let files = fs_1.default
                            .readdirSync(localeDirectory)
                            .filter((x) => x.match(/[.]json$/));
                        for (let file of files) {
                            let namespace = (_a = /^(.*)[.]json$/.exec(file)) === null || _a === void 0 ? void 0 : _a[1];
                            let fileContent = JSON.parse(fs_1.default.readFileSync(path_1.default.join(localeDirectory, file), 'utf-8'));
                            localizationData[locale][namespace] = Object.assign(Object.assign({}, localizationData[locale][namespace]), fileContent);
                        }
                    }
                }
            }
            return localizationData;
        });
    }
    get localizationContext() {
        if (!this._localizationContext)
            throw new Error('localizationContext requested before init() completed.');
        return this._localizationContext;
    }
}
exports.BoutikMultilocalePlugin = BoutikMultilocalePlugin;
//# sourceMappingURL=BoutikMultilocalePlugin.js.map